<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.JobNumber')" name="jobNoConfigList">
          <no-config-list
            v-if="!userNewJobNoRule"
            tab-name="JobNo"
            :tab-title="$t('SystemMaintenance.JobNumber')"
            :tab-number-title="$t('SystemMaintenance.JobNumber')"
            :max-length="19"
            :show-depart="true"
            :show-warehouse-code="true"
            :show-partner-warehouse-code="true"
            default-pattern="${office}${salesDepart}${opDepart}${lob}${port}${Y}${M}${SSSSS:ON}"
            :remark="$t('SystemMaintenance.NoteMainAndSplit19')"
            :show-custom-job-type="true"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.MainOrderNumber')" name="mblNoConfigList">
          <no-config-list
            tab-name="MblNo"
            :tab-title="$t('SystemMaintenance.MainOrderNumber')"
            :tab-number-title="$t('SystemMaintenance.MainOrderNumber')"
            :max-length="16"
            :is-mbl="true"
            :show-hbl-lob="true"
            :show-job-sequence="true"
            :show-job-no="true"
            :show-port="false"
            :show-date="false"
            default-pattern="${office}${salesDepart}${opDepart}${lob}${port}${Y}${M}${SSSSS:ON}"
            :remark="$t('SystemMaintenance.NoteNumberIsUpLong')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.SubOrderNumber')" name="hblNoConfig">
          <no-config-list
            tab-name="HblNo"
            :tab-title="$t('SystemMaintenance.SubOrderNumber')"
            :tab-number-title="$t('SystemMaintenance.SubOrderNumber')"
            :max-length="21"
            :show-hbl-lob="true"
            :show-lob="false"
            :show-port="false"
            :show-job-no="true"
            :show-date="false"
            :show-job-sequence="true"
            :show-partner-warehouse-code="true"
            :show-random-letters="true"
            default-pattern="${jobNo}"
            :remark="$t('SystemMaintenance.NoteIsUpToLong')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.WarehouseEntryNumber')" name="warehouseNoConfigList">
          <no-config-list
            tab-name="WareHouseNo"
            :tab-title="$t('SystemMaintenance.BookingNumber')"
            :tab-number-title="$t('SystemMaintenance.WarehouseEntryNumber')"
            :max-length="21"
            :show-office="false"
            :show-job-no="true"
            :show-date="false"
            :show-job-sequence="true"
            :show-warehouse-no="true"
            :show-partner-warehouse-code="true"
            :is-warehouse="true"
            default-pattern="${port}${JJJJJ}"
            :remark="$t('SystemMaintenance.NoteYouHaveSelectedLength')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.DomesticBill')" name="BillingInternalNoConfigList">
          <no-config-list
            tab-name="BillingInternalNo"
            :tab-title="$t('SystemMaintenance.DomesticBillNo')"
            :tab-number-title="$t('SystemMaintenance.DomesticBillNo')"
            :show-op="false"
            :show-lob="false"
            :show-net-code="true"
            :show-user-code="false"
            :show-port="false"
            :show-io="true"
            :show-bill-date="true"
            default-pattern="${office}${netCode}${Y}${M}${SSSSS:N}${io}"
            :remark="$t('SystemMaintenance.NoteIsUpToLong4')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.OverseasBillNumber')" name="billingNoConfigList">
          <no-config-list
            tab-name="BillingNo"
            :tab-title="$t('SystemMaintenance.OverseasBillNumber')"
            :tab-number-title="$t('SystemMaintenance.OverseasBillNumber')"
            :show-lob="false"
            :show-net-code="true"
            :show-port="false"
            :show-io="true"
            :show-bill-date="true"
            default-pattern="${office}${netCode}${Y}${M}${SSSSS:N}${io}"
            :remark="$t('SystemMaintenance.NoteIsUpToLong2')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.PaymentApplicationForm')" name="billPaymentNoConfigList">
          <no-config-list
            tab-name="BillPaymentNo"
            :tab-title="$t('SystemMaintenance.PaymentApprovalForm')"
            :tab-number-title="$t('SystemMaintenance.PaymentApplicationForm')"
            :show-lob="false"
            :show-port="false"
            :show-op="false"
            default-pattern="${office}${YY}${MM}${DD}${SSS:OD}"
            :remark="$t('SystemMaintenance.NoteIsUpToLong3')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.BillOfLadingSerialNumber')" name="billNoConfig">
          <no-config-list
            tab-name="BillNo"
            :tab-title="$t('SystemMaintenance.BillOfLadingSerialNumber')"
            :tab-number-title="$t('SystemMaintenance.BillOfLadingSerialNumber')"
            :show-hbl-lob="true"
            :show-lob="false"
            :show-port="false"
            :show-job-no="true"
            :show-date="false"
            :show-job-sequence="true"
            :show-bill="true"
            default-pattern
            remark="说明:提单流水号最长16位。"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.DomesticStatement')" name="BillingGroupInternalNo">
          <no-config-list
            tab-name="BillingGroupInternalNo"
            :tab-title="$t('SystemMaintenance.DomesticStatement')"
            :tab-number-title="$t('SystemMaintenance.DomesticStatement')"
            :show-op="false"
            :show-lob="false"
            :show-net-code="true"
            :show-user-code="false"
            :show-port="false"
            :show-io="false"
            :show-bill-date="true"
            default-pattern="${office}${YY}${MM}${SSSS:OFM}${io}"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.ForeignStatement')" name="BillingGroupNo">
          <no-config-list
            tab-name="BillingGroupNo"
            :tab-title="$t('SystemMaintenance.ForeignStatement')"
            :tab-number-title="$t('SystemMaintenance.ForeignStatement')"
            :show-op="false"
            :show-lob="false"
            :show-net-code="true"
            :show-user-code="false"
            :show-port="false"
            :show-io="false"
            :show-bill-date="true"
            default-pattern="${office}${YY}${MM}${SSSS:OFM}${io}"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_WriteOffSerialNumber')" name="WriteOffNo">
          <no-config-list
            tab-name="WriteOffNo"
            :tab-title="$t('CargoMsg.Cargo_WriteOffSerialNumber')"
            :tab-number-title="$t('CargoMsg.Cargo_WriteOffSerialNumber')"
            :show-op="false"
            :show-lob="false"
            :show-user-code="false"
            :show-port="false"
            :show-rp="true"
            :show-io="false"
            :show-pay-date="true"
            default-pattern="${office}${rp}${YY}${MM}${SSSS:OFM}"
          />
        </el-tab-pane>
        <!--        这里按普通单号规则生成，暂时屏蔽-->
        <!--        <el-tab-pane :lazy="true" label="FBA委托单号" name="trustNoConfigList">
          <no-config-list
            tab-name="TrustNo"
            tab-title="FBA委托单号"
            :max-length="14"
            :show-depart="true"
            :show-warehouse-code="true"
            default-pattern="${office}${salesDepart}${opDepart}${lob}${port}${Y}${M}${SSSSS:ON}"
            remark="说明:委托单号最长16位，预留后两位作为主单和拆单标记，因此，在此页配置的单号长度不可以超过14。"
            :show-custom-job-type="true"
          />
        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import noConfigList from './components/noConfigList'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'JobNoConfig',
  components: { noConfigList },
  data() {
    return {
      loading: null,
      userNewJobNoRule: false,
      activeTabName: ''
    }
  },
  async created() {
    this.loading = getLoading()
    await cache.load(cacheName.CONFIG)
    this.userNewJobNoRule = cache.config.get('UseNewJobNoRule') === '1'
    this.activeTabName = 'jobNoConfigList'
    this.loading.close()
  }
}
</script>
